import { BaseRepository } from "approot/global/repository/baseRepository";
import { FileAttachmentsSettings, ServerSettings, SmsSettings, CommonServerSettings, PushSettings, SchoolInfoSettings, MailSettings, SecuritySettings, IntegrationSettings, CheckConnectionResult, UserAccountsSettings, UserAuthorizationSettings, PopUpWindowOnLoginScreenSettings, UrlInfo, VideoConfSettings, VideoConferenceSettingDto, ChatsSettings } from "./settings.model";
import { MovePeriodDto } from "approot/school/movement/movement.model";

export class SettingsRepository extends BaseRepository {
	getSafeNetworkSchools(): Promise<{ id: number; name: string }[]> {
		return this.$http.get("/webapi/settings/security/networks/schools").then(this.handleResponse, this.handleError);
	}

	getSafeNetworks(schoolId: number): Promise<{ schoolId: number; ranges: string }> {
		return this.$http.get("/webapi/settings/security/networks", { params: { schoolId } }).then(this.handleResponse, this.handleError);
	}

	validateSafeNetworks(schoolId: number, ranges: string): Promise<string[]> {
		return this.$http.post("/webapi/settings/security/networks/validate", { schoolId, ranges }).then(this.handleResponse, this.handleError);
	}

	saveSafeNetworks(schoolId: number, ranges: string): Promise<void> {
		return this.$http.post("/webapi/settings/security/networks", { schoolId, ranges }).then(this.handleResponse, this.handleError);
	}

	// получает настройки
	getServerSettings(): Promise<ServerSettings> {
		return this.$http.get("/webapi/settings/server")
			.then(this.handleResponse, this.handleError);
	}

	// получает код доверенного приложения
	getCommonServerSettings(): Promise<CommonServerSettings> {
		return this.$http.get("/webapi/settings/common")
			.then(this.handleResponse, this.handleError);
	}

	// сохраняет Настройки сервера
	saveCommonServerSettings(serverSettings: ServerSettings) {
		return this.$http.post("/webapi/settings/common", serverSettings)
			.then(this.handleResponse, this.handleError);
	}

	// получает Настройки файловых вложений
	getSmsSettings(): Promise<SmsSettings> {
		return this.$http.get("/webapi/settings/sms")
			.then(this.handleResponse, this.handleError);
	}

	// получает настройку 'Требовать заполнения поля "Дата рождения" у родителей'
	requireParentBirthDate(): Promise<boolean> {
		return this.$http.get("/webapi/settings/requireParentBirthDate")
			.then(this.handleResponse, this.handleError);
	}

	// сохраняет Настройки файловых вложений
	saveSmsSettings(smsSettings: SmsSettings) {
		return this.$http.post("/webapi/settings/sms", smsSettings)
			.then(this.handleResponse, this.handleError);
	}

	// получает Настройки PUSH уведомлений
	getPushSettings(): Promise<PushSettings> {
		return this.$http.get("/webapi/settings/push")
			.then(this.handleResponse, this.handleError);
	}

	// сохраняет Настройки PUSH уведомлений
	savePushSettings(smsSettings: PushSettings) {
		return this.$http.post("/webapi/settings/push", smsSettings)
			.then(this.handleResponse, this.handleError);
	}

	// получает настройки почты
	getMailSettings(): Promise<MailSettings> {
		return this.$http.get("/webapi/settings/mail")
			.then(this.handleResponse, this.handleError);
	}

	// сохраняет настройки почты
	saveMailSettings(mailSettings: MailSettings) {
		return this.$http.post("/webapi/settings/mail", mailSettings)
			.then(this.handleResponse, this.handleError);
	}

	// проверяет email
	testEMail(email: string) {
		return this.$http.post("/webapi/settings/testemail", JSON.stringify(email))
			.then(this.handleResponse, this.handleError);
	}

	// 
	getMovePeriods(globalYear: number): Promise<MovePeriodDto[]> {
		return this.$http.get("/webapi/settings/moveperiods", {
			params: { globalYear: globalYear }
		}).then(this.handleResponse, this.handleError);
	}

	getMovePeriodsPreSchool(globalYear: number): Promise<MovePeriodDto[]> {
		return this.$http.get("/webapi/settings/moveperiods/preschool", {
			params: { globalYear: globalYear }
		}).then(this.handleResponse, this.handleError);
	}

	saveMovePeriodsPermission(globalYear: number, periodPermit: number, addSchoolPeriodPermit: number): Promise<void> {
		return this.$http.post("/webapi/settings/moveperiods/permission", null, { 
			params: { globalYear, periodPermit, addSchoolPeriodPermit }
		}).then(this.handleResponse, this.handleError);
	}

	saveMovePeriodsPreSchoolPermission(globalYear: number, periodPermit: number): Promise<void> {
		return this.$http.post("/webapi/settings/moveperiods/preschool/permission", null, { 
			params: { globalYear, periodPermit }
		}).then(this.handleResponse, this.handleError);
	}

	saveMovePeriods(globalYear: number, periods: MovePeriodDto[]): Promise<void> {
		return this.$http.post("/webapi/settings/moveperiods", periods, { 
			params: { globalYear }
		}).then(this.handleResponse, this.handleError);
	}

	
	// получает  настройки безопасности
	getSecuritySettings(): Promise<SecuritySettings> {
		return this.$http.get("/webapi/settings/security")
			.then(this.handleResponse, this.handleError);
	}

	// сохраняет  настройки безопасности
	saveSecuritySettings(securitySettings: SecuritySettings) {
		return this.$http.post("/webapi/settings/security", securitySettings)
			.then(this.handleResponse, this.handleError);
	}

	getReadOnlyAccessFlag(): Promise<boolean> {
		return this.$http.get("/webapi/appflags/readOnlyAccess")
			.then(this.handleResponse, this.handleError);
	}

	// получает настройки интеграции
	getIntegrationSettings(): Promise<IntegrationSettings> {
		return this.$http.get("/webapi/settings/integration")
			.then(this.handleResponse, this.handleError);
	}

	// сохраняет настройки интеграции
	saveIntegrationSettings(integrationSettings: IntegrationSettings) {
		return this.$http.post("/webapi/settings/integration", integrationSettings)
			.then(this.handleResponse, this.handleError);
	}

	// получает букву мужского пола
	getMaleLetter(): Promise<string> {
		return this.$http.get("/webapi/settings/maleLetter")
			.then(this.handleResponse, this.handleError);
	}

	// получает букву женского пола
	getFemaleLetter(): Promise<string> {
		return this.$http.get("/webapi/settings/femaleLetter")
			.then(this.handleResponse, this.handleError);
	}

	getCheckConnectionResults(urlInfos: UrlInfo[]): Promise<CheckConnectionResult[]> {
		return this.$http.post("/webapi/checkconnections", urlInfos)
			.then(this.handleResponseSimple, this.handleError);
	}

	// получает учетные записи пользователей
	getUserAccountsSettings(): Promise<UserAccountsSettings> {
		return this.$http.get("/webapi/settings/useraccounts")
			.then(this.handleResponse, this.handleError);
	}

	// сохраняет учетные записи пользователей
	saveUserAccountsSettings(userAccountsSettings: UserAccountsSettings) {
		return this.$http.post("/webapi/settings/useraccounts", userAccountsSettings)
			.then(this.handleResponse, this.handleError);
	}

	// получает настройки авторизации пользователей
	getUserAuthorizationSettings(): Promise<UserAuthorizationSettings> {
		return this.$http.get("/webapi/settings/userauthorization")
			.then(this.handleResponse, this.handleError);
	}

	// сохраняет настройки авторизации пользователей
	saveUserAuthorizationSettings(userAuthorizationSettings: UserAuthorizationSettings) {
		return this.$http.post("/webapi/settings/userauthorization", userAuthorizationSettings)
			.then(this.handleResponse, this.handleError);
	}

	resetLoginPassAllowed() {
		return this.$http.post("/webapi/settings/loginpassalowed/reset")
			.then(this.handleResponse, this.handleError);
	}

	// получает настройки авторизации пользователей
	getPopupWindowOnLoginScreenSettings(): Promise<PopUpWindowOnLoginScreenSettings> {
		return this.$http.get("/webapi/settings/preloginnotice")
			.then(this.handleResponse, this.handleError);
	}

	// сохраняет настройки авторизации пользователей
	savePopupWindowOnLoginScreenSettings(popUpWindowOnLoginScreenSettings: PopUpWindowOnLoginScreenSettings) {
		return this.$http.post("/webapi/settings/popupwindowonloginscreen", popUpWindowOnLoginScreenSettings)
			.then(this.handleResponse, this.handleError);
	}

	// получает сведения об образовательных организациях
	getSchoolInfoSettings(): Promise<SchoolInfoSettings> {
		return this.$http.get("/webapi/settings/schoolinfo")
			.then(this.handleResponse, this.handleError);
	}

	// сохраняет сведения об образовательных организациях
	saveSchoolInfoSettings(schoolInfoSettings: SchoolInfoSettings) {
		return this.$http.post("/webapi/settings/schoolinfo", schoolInfoSettings)
			.then(this.handleResponse, this.handleError);
	}

	// получает Настройки файловых вложений
	getFileAttachmentsSettings(): Promise<FileAttachmentsSettings> {
		return this.$http.get("/webapi/settings/fileattachments")
			.then(this.handleResponse, this.handleError);
	}

	// сохраняет Настройки файловых вложений
	saveFileAttachmentsSettings(fileAttachmentsSettings: FileAttachmentsSettings) {
		return this.$http.post("/webapi/settings/fileattachments", fileAttachmentsSettings)
			.then(this.handleResponse, this.handleError);
	}

	// Получает настройки API Шлюза видеоконференций
	getVideoConfSettings(): VideoConfSettings {
		return this.$http.get("/webapi/settings/videoconf")
			.then(this.handleResponse, this.handleError);

	}

	// Сохраняет Настройки API Шлюза видеоконференций
	saveVideoConfSettings(videoConfSettings: VideoConfSettings) {
		return this.$http.post("/webapi/settings/videoconf", videoConfSettings)
			.then(this.handleResponse, this.handleError);
	}

	getOrgVideoConfSettings(): Promise<VideoConferenceSettingDto[]> {
		return this.$http.get("/webapi/video-conf")
			.then(this.handleResponse, this.handleError);
	}

	createVideoConfSetting(dto: VideoConferenceSettingDto): Promise<VideoConferenceSettingDto> {
		return this.$http.put("/webapi/video-conf", dto)
			.then(this.handleResponse, this.handleError);
	}

	editVideoConfSetting(dto: VideoConferenceSettingDto): Promise<VideoConferenceSettingDto> {
		return this.$http.post("/webapi/video-conf", dto)
			.then(this.handleResponse, this.handleError);
	}

	deleteVideoConfSetting(id: number): Promise<void> {
		const params = { id: id };

		return this.$http.delete("/webapi/video-conf", { params: params })
			.then(this.handleResponse, this.handleError);
	}

	getChatsSettings(): Promise<ChatsSettings> {
		return this.$http.get("/webapi/settings/chats")
			.then(this.handleResponse, this.handleError);
	}

	saveChatsSettings(settings: ChatsSettings): Promise<void> {
		return this.$http.post("/webapi/settings/chats", settings)
			.then(this.handleResponse, this.handleError);
	}
}
